import { parse, ParsedQuery, stringify } from 'query-string';
import {
  parseDateRange,
  stringifyDateRange,
} from 'components/organisms/projects-report/common/range-picker/transformer';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FilterableField } from 'components/organisms/tasks/fields';
import {
  TermSeparator,
  ValueSeparator,
} from 'components/organisms/tasks/filters/separators';
import {
  from_filter_query,
  ParsedFilterQuery,
  to_filter_query,
  to_parsed_filter_query,
} from 'components/pages/filter-transformer';
import { Transformer as SearchTransformer } from 'hooks/use-search';
import { ReportFilter } from './types';

export type ParsedReportFilterQuery = ParsedFilterQuery & {
  range: string;
};

export const to_report_filter_query = (
  filter: ReportFilter,
): ParsedReportFilterQuery => ({
  ...to_filter_query(filter),
  range: stringifyDateRange(filter.range),
});

export const to_query = (filter: ReportFilter): string =>
  `?${stringify(to_report_filter_query(filter))}`;

export const from_report_filter_query =
  (lookup: Record<string, FilterableField>, defaultRange: DateRange) =>
  (query: Partial<ParsedReportFilterQuery>): ReportFilter => ({
    ...from_filter_query(lookup)(query),
    range: parseDateRange((query.range ?? '') as string, defaultRange),
  });

export const convert_to_range_from_dates = (
  parsed: ParsedQuery,
): Partial<ParsedFilterQuery> => ({
  range:
    parsed.range == null && parsed.startDate != null && parsed.endDate != null
      ? `custom${TermSeparator}${parsed.startDate}${ValueSeparator}${parsed.endDate}`
      : parsed.range,
});

export const to_parsed_report_filter_query = (
  query: ParsedQuery,
): Partial<ParsedFilterQuery> => ({
  ...to_parsed_filter_query(query),
  ...convert_to_range_from_dates(query),
});
export const from_search =
  (lookup: Record<string, FilterableField>, defaultRange: DateRange) =>
  (filter: string): ReportFilter => {
    const parsed = parse(filter);

    return from_report_filter_query(
      lookup,
      defaultRange,
    )(to_parsed_report_filter_query(parsed));
  };

export const getReportFilterTransformer = (
  lookup: Record<string, FilterableField>,
  defaultRange: DateRange,
): SearchTransformer<ReportFilter> => ({
  from: (parsed) =>
    from_report_filter_query(
      lookup,
      defaultRange,
    )(to_parsed_report_filter_query(parsed)),
  to: to_report_filter_query,
});
